import { render, staticRenderFns } from "./TableActions.vue?vue&type=template&id=ef9eb6f2&scoped=true&"
import script from "./TableActions.vue?vue&type=script&lang=js&"
export * from "./TableActions.vue?vue&type=script&lang=js&"
import style0 from "./TableActions.vue?vue&type=style&index=0&id=ef9eb6f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9eb6f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef9eb6f2')) {
      api.createRecord('ef9eb6f2', component.options)
    } else {
      api.reload('ef9eb6f2', component.options)
    }
    module.hot.accept("./TableActions.vue?vue&type=template&id=ef9eb6f2&scoped=true&", function () {
      api.rerender('ef9eb6f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/TableActions.vue"
export default component.exports